import Widget from "lib/widget";

const POLL_INTERVAL = 5 * 1000;
const GENERATION_TIMEOUT = 10 * 60 * 1000;
const TIMEOUT_MESSAGE = "Document generation is taking longer than expected. Please check back later or try again.";

export const CERT_ACTIONS = {
  generate_unsigned: "generate_unsigned",
  unsigned_generated: "unsigned_generated",
  certificate_signed: "certificate_signed",
};

class BaseCertificateWidget extends Widget {
  bindBase() {
    this.baseUrl = `${window.location.origin}${window.location.pathname}`;
  }

  // Show the Certificate Actions container based on the action
  showAction(action) {
    Object.values(CERT_ACTIONS).forEach((name) => {
      const container = $(`#cert-action-${name}-${this.checklistId}`);
      const isActive = name === action;
      container.toggleClass("d-none", !isActive);
      if (isActive) this.enableContainer(container);
    });
  }

  // Fetch the certificate actions and show the appropriate container
  // When certificate is being generated, the actions are fetched and shown
  fetchAndShowAction() {
    $.ajax({
      url: `${this.baseUrl}/checklists/${this.checklistId}/certificate_actions`,
      type: "GET",
      dataType: "json",
      success: (response) => {
        this.showAction(response.action);
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  // Disable all buttons and links in the container
  // Buttons and anchor tags are treated differently
  disableContainer(container) {
    container.find(".js-cert-btn").each((_, el) => {
      const $el = $(el);
      const isLink = el.tagName === "A";
      $el.data("was-disabled", isLink ? $el.hasClass("disabled") : $el.prop("disabled"));

      if (isLink) {
        $el.addClass("disabled").attr({ "aria-disabled": "true", tabindex: "-1" });
      } else {
        $el.prop("disabled", true);
      }
    });
  }

  // Enable all buttons and links in the container
  // Buttons and anchor tags are treated differently
  enableContainer(container) {
    container.find(".js-cert-btn").each((_, el) => {
      const $el = $(el);
      if ($el.data("was-disabled")) return;

      if (el.tagName === "A") {
        $el.removeClass("disabled").removeAttr("aria-disabled").removeAttr("tabindex");
      } else {
        $el.prop("disabled", false);
      }
    });
  }

  statusMessage() {
    return this.spinner().siblings(".js-cert-status-message");
  }

  updateProcessingMessage(text) {
    this.statusMessage().text(text);
  }

  isTerminalFailure(response) {
    const terminalStatuses = ["failed", "stopped", "interrupted"];
    return response.state === "failed" || terminalStatuses.includes(response.job_status) || !response.job_status;
  }

  stopWithMessage(message) {
    this.stopWatchingStatus();
    this.spinner().addClass("d-none");
    this.enableContainer(this.activeContainer);
    this.updateProcessingMessage(message);
  }

  handleJobStatusResponse(response) {
    if (this.isTerminalFailure(response)) {
      this.stopWithMessage(response.message);
    } else if (response.message) {
      this.updateProcessingMessage(response.message);
    }
  }

  watchStatus() {
    this.statusMessage().text("").removeClass("d-none");
    this.interval = setInterval(() => this.checkStatus(), POLL_INTERVAL);
    this.timeoutTimer = setTimeout(() => this.stopWithMessage(TIMEOUT_MESSAGE), GENERATION_TIMEOUT);
  }

  stopWatchingStatus() {
    clearInterval(this.interval);
    clearTimeout(this.timeoutTimer);
  }
}

export default BaseCertificateWidget;
